<div class="paginator">
  <span>{{ label() }}</span>

  <div class="paginator__buttons">
    <button
      class="paginator__button"
      [class.paginator__button--disabled]="paginatorService.currentPage() === 0"
      (click)="paginatorService.previousPage()">
      <span>Previous</span>
    </button>

    @for (page of paginatorService.pages(); track page) {
      <button
        class="paginator__button paginator__page-button"
        [class.paginator__page-button--active]="
          page === paginatorService.currentPage()
        "
        (click)="paginatorService.goToPage(page)">
        <span>{{ page + 1 }}</span>
      </button>
    }

    <button
      class="paginator__button"
      [class.paginator__button--disabled]="
        paginatorService.currentPage() === paginatorService.totalPages() - 1
      "
      (click)="paginatorService.nextPage()">
      <span>Next</span>
    </button>
  </div>
</div>
